<cpd-dialog-container2
  *ngIf="{
    favoriteOccupations: favoriteOccupations$ | async
  } as data"
  size="1170px"
  title="Saved Occupations"
>
  <section dialog-body>
    <section class="grid-x align-center-middle gap-8">
      <div *ngFor="let occupation of data.favoriteOccupations">
        <cpd-occupation-card
          [occupation]="occupation"
          (occupationClick)="onOccupationClick($event)"
        >
        </cpd-occupation-card>
      </div>
    </section>
  </section>
</cpd-dialog-container2>
